import React from 'react';
import { Drawer, Grid } from 'antd';
import { ServiceRequestData } from '@services/types/Relationship/MyCalls/types';
import RequestDetails from './RequestDetails';
import RequestMessages from './RequestMessages';
import { MessagesActionNames } from './RequestMessages/MessagesHeader/MessagesActions';

const { useBreakpoint } = Grid;

interface ServiceRequestDetailsProps {
  open: boolean;
  onClose: () => void;
  request?: ServiceRequestData;
  onMutateRequest?: (action: MessagesActionNames, requestId: number) => void;
}

const ServiceRequestDetails = ({
  open,
  onClose,
  request,
  onMutateRequest,
}: ServiceRequestDetailsProps) => {
  const screens = useBreakpoint();

  return (
    <Drawer
      open={open}
      width={screens?.xs ? '80%' : '50%'}
      placement="right"
      bodyStyle={{
        padding: 16,
      }}
      onClose={onClose}
      closable={false}
      destroyOnClose
    >
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <RequestDetails request={request} />
        <RequestMessages request={request} onMutateRequest={onMutateRequest} />
      </div>
    </Drawer>
  );
};

export default ServiceRequestDetails;
